import { render, staticRenderFns } from "./pagination1.vue?vue&type=template&id=40e9e377"
import script from "./pagination1.vue?vue&type=script&lang=js"
export * from "./pagination1.vue?vue&type=script&lang=js"
import style0 from "./pagination1.vue?vue&type=style&index=0&id=40e9e377&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports